import BaseExtension from './base';

import { createElement, addClass, removeClass } from '../utils';

import createSvg, { BROADCAST_OFF, BROADCAST_ON } from '../svgs';

import popover from './helpers/popover';

const CN = 'rmp-ext-live';
const BROADCAST_ON_CN = `${CN}--live`;

export default class LiveExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options, ['timeupdate', 'progress']);
      this.logger.debug('play:extension:creating');

      this.render();
      this.addEvent(this.$el, 'click', this.toggle.bind(this));

      this.logger.debug('live:extension:created');
   }

   render() {
      /** @type {HTMLMediaElement} */
      this.$el = createElement('button', { type: 'button', class: CN});

      createSvg(this.$el, BROADCAST_OFF, {class: 'broadcast-off', width: 50, height: 50, viewBox: '0 0 50 50'});
      createSvg(this.$el, BROADCAST_ON, {class: 'broadcast-on', width: 50, height: 50,  viewBox: '0 0 50 50'});

      setTimeout(() => {
         const text = this.player.isLive() ? 'Live' : 'Go to live';
         popover(this, { $button: this.$el, text });
      }, 100);
   }

   toggle() {
      this.goToLive();
   }

   goToLive() {
      this.player.goToLive();
      addClass(this.$el, BROADCAST_ON_CN);
   }

   onTimeupdate() {
      if (!this.player.isLive()) {
         this.$el.setAttribute('aria-label', 'Go to live');
         removeClass(this.$el, BROADCAST_ON_CN);
      } else {
         this.$el.setAttribute('aria-label', 'Live');
         addClass(this.$el, BROADCAST_ON_CN);
      }
   }

   onProgress() {
      if (!this.player.isLive()) {
         this.$el.setAttribute('aria-label', 'Go to live');
         removeClass(this.$el, BROADCAST_ON_CN);
      } else {
         this.$el.setAttribute('aria-label', 'Live');
         addClass(this.$el, BROADCAST_ON_CN);
      }
   }

   getElement() {
      return this.$el;
   }

   destroy() {
      super.destroy();

      const parent = this.$el.parentNode;
      parent.removeChild(this.$el);
      this.$el = null;
   }
}
